import { z } from 'my-zod'

const metadataUnit = z.object({
  title: z.string(),
  value: z.string()
})

export const baseMetadata = z.object({
  pricing: metadataUnit.array(),
  fullTermPayment: z.boolean().nullish()
})

export type baseMetadata = z.infer<typeof baseMetadata>

export const subscriptionPlanMetadata = baseMetadata.augment({
  'Contract Terms & Conditions': metadataUnit.array(),
  planDetails: metadataUnit.array().optional()
})

export type subscriptionPlanMetadata = z.infer<typeof subscriptionPlanMetadata>

export const subscriptionPlanPriceMetadata = baseMetadata
export type subscriptionPlanPriceMetadata = z.infer<typeof subscriptionPlanPriceMetadata>
